export const subscriberRoles: string[] = ["Fan", "Scout", "Reporter", "Expert", "DronePilot"];
